// extracted by mini-css-extract-plugin
module.exports = {"anchorButton":"AnchorButton_anchorButton__vNGlE","linkIcon":"AnchorButton_linkIcon__taZUm","headingContainer":"AnchorButton_headingContainer__RFhgM"};